import { Component } from '@angular/core';
import { AuthFlow } from '../../../../models/account/enum/auth-flow.enum';
import { AuthViewModel } from '../../viewModels/auth-view-model';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../models/base/base-component';
import { NavigationService } from '../../../../services/navigation.service';
import { ToastService } from '../../../../modules/toasts/service/toast.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: false
})
export class AuthComponent extends BaseComponent {
  // View Properties
  private logoClickCount: number = 0;

  constructor(
    public viewModel: AuthViewModel,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService,
    private navigationService: NavigationService
  ) {
    super();
  }

  parseAuthFlow() {
    const urlSub = this.route.url.subscribe(url => {
      switch (url[url.length - 1].path) {
        case 'sign-in': {
          this.viewModel.connectToAuthFlow(AuthFlow.SignIn);
          break;
        }
        case 'forgot-password': {
          this.viewModel.connectToAuthFlow(AuthFlow.ForgotPassword);
          break;
        }
        case 'reset-password': {
          this.viewModel.connectToAuthFlow(AuthFlow.ResetPassword);
          break;
        }
        case 'new-password': {
          this.viewModel.connectToAuthFlow(AuthFlow.SetNewPassword);
          break;
        }
      }
    });
    this.pushSub(urlSub);
  }

  override setupBindings() {
    this.parseAuthFlow();
    // Navigate to the account page on successful auth
    this.viewModel.authSuccessNavigateToHome.subscribeWhileAlive({
      owner: this,
      next: () => {
        this.router
          .navigate(['metrics'])
          .then(() => this.viewModel.signedIn())
          .catch(() => this.viewModel.signInFailed());
      }
    });
    // Navigate to the reset password page
    const authFlowSubject = this.viewModel.nextAuthFlow.consumeFlag(nextAuthFlow => {
      switch (nextAuthFlow) {
        case AuthFlow.ResetPassword:
          this.navigationService.resetPassword();
          break;
        case AuthFlow.SetNewPassword:
          this.navigationService.newPassword();
          break;
        case AuthFlow.SignIn:
          this.navigationService.signIn();
          break;
      }
    });
    this.pushSub(authFlowSubject);
  }

  logoClicked() {
    // If the user clicks the logo 7 times quickly, it will reset the caches
    this.logoClickCount++;
    if (this.logoClickCount > 6) {
      this.viewModel.clearCaches();
      this.logoClickCount = 0;
      this.toastService.publishInfoMessage('All caches have been cleared.', 'Caches cleared');
    }
    setTimeout(() => (this.logoClickCount = 0), 5000);
  }
}
